import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetProductions = async (params: {
  page: number;
  limit: number;
  search?: string;
  product_id?: string | null;
  start_date?: string | null;
  end_date?: string | null;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/productions`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load productions.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetProductionById = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/productions/id`, {
      params: { id },
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load production details.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateProduction = async (
  formData: any,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/productions/create`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create production.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};
